import { SharedService } from './shared/shared.service';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzTableModule } from 'ng-zorro-antd/table';
import { SharedModule } from './shared/shared.module';
import { RouterOutlet } from '@angular/router';


@Component( {
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    TranslateModule,
    NzTableModule,
    SharedModule,
    RouterOutlet
]
} )
export class AppComponent implements AfterViewInit, OnDestroy {
  private sharedService = inject(SharedService);
  private cdr = inject(ChangeDetectorRef);
  private translate = inject(TranslateService);

  title = 'Dynamica Smart Rates';
  show = false;
  isLoading$: Subscription;
  currentLang = 'en';
  languages = ['de', 'en'];

  constructor() {
    this.translate.addLangs( this.languages );
    this.translate.setDefaultLang( this.currentLang );
    this.translate.use( this.currentLang );
  }

  ngAfterViewInit(): void {
    this.isLoading$ = this.sharedService.loaderSubject
      .subscribe( ( state: any ) => {
        this.show = state.show;
        this.cdr.detectChanges();
      } );
  }

  ngOnDestroy(): void {
    this.isLoading$.unsubscribe();

  }
}
